import { api } from '$app/api';

export const getDashboardBookings = async (payload) => {
  const { data } = await api.post('/dashboard/bookings', payload);
  return data;
};
